module.exports = __webpack_public_path__ + "media/images/usps_logo-b270aa5b462edff7053833efa7c3bc90.png";